import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./userSlice"
import courseSlice from './courseSlice'
import expertSlice from './expertSlice'
import dashboardslice from './dashboardslice'
import notificationslice from './notificationslice'
import helpAndSupportSlice from './helpAndSupportSlice'
import appSettingSlice from './appSettingSlice'
import contentSlice from './contentSlice'
import sessionSlice from './sessionSlice'
import communitySlice from './communitySlice'
import paymentAndTransactionSlice from './paymentsAndTransactionSlice'
import preferenceSlice from './preferenceSlice'
import adminSlice from './adminSlice'
import referralAndRewardSlice from './referralAndRewardSlice'
import banner from './bannerSlice'
import certificate from './certificateSlice'
import teachersSubscription from './teacherSubscriptionSlice'
import teachersWithdrawal from './teacherWithdrawalSlice'

export const store = configureStore({
  reducer: {
    authSlice: authReducer,
    courseSlice: courseSlice,
    expertSlice: expertSlice,
    dashboardslice: dashboardslice,
    notificationslice: notificationslice,
    helpAndSupportSlice: helpAndSupportSlice,
    appSettingSlice: appSettingSlice,
    contentSlice: contentSlice,
    sessionSlice: sessionSlice,
    communitySlice: communitySlice,
    paymentAndTransactionSlice: paymentAndTransactionSlice,
    preferenceSlice: preferenceSlice,
    adminSlice: adminSlice,
    referralAndRewardSlice: referralAndRewardSlice,
    banner: banner,
    certificate: certificate,
    teachersSubscription: teachersSubscription,
    teachersWithdrawal: teachersWithdrawal,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: false // Disable Redux DevTools temporarily
})